import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { ModalProgrammatic } from 'buefy';

import DfrBatchUpdateModal from '@/components/dfr/DfrBatchUpdateModal.vue';

import { useStore } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'DfrBatchUpdate',
  setup(__props) {

const store = useStore();

const selectedLength = ref<number>(0);
watch(
  () => store.getters['dfr/getSelected'],
  v => {
    selectedLength.value = v.length;
  }
);

const show = ref(false);

function openModal() {
  show.value = true;
  ModalProgrammatic.open({
    component: DfrBatchUpdateModal,
    hasModalCard: true,
    props: {
      show,
    },
    events: {
      'modal:close': () => {
        show.value = false;
      },
    },
  });
}

return { __sfc: true,store, selectedLength, show, openModal }
}

})